import { countries } from 'constants/locations';
import { CountryCodeMap } from 'components/join/components/country-code';

export async function getCountryCodeByIP(): Promise<string | null> {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    return data.country_code; // This returns the ISO country code (e.g., 'US', 'GB', etc.)
  } catch (e) {
    console.warn('Failed to detect country by IP:', e);
    return null;
  }
}

export function findCountryByCode(countryCode: string): string | null {
  if (!countryCode) return null;

  // Find the country name by matching the country code
  const countryEntry = Object.entries(CountryCodeMap).find(
    ([_, countryData]: [string, any]) => countryData.countryCode === countryCode.toUpperCase()
  );

  if (countryEntry) {
    const countryName = countryEntry[0];
    // Verify the country exists in our countries list
    const found = countries.find(c => c === countryName);
    return found || null;
  }

  return null;
}

export async function detectUserCountry(): Promise<string | null> {
  const detectedCountryCode = await getCountryCodeByIP();
  return findCountryByCode(detectedCountryCode || '');
}
